/* Copyright (c) 2021-2024 VMware, Inc. All rights reserved. VMware Confidential */

export enum OperatorRoleEnum {
    // Operator roles
    OPERATOR_READ_ONLY = "vcds:operator-ro",                    // "Operator Read Only"
    OPERATOR_READ_WRITE = "vcds:operator-rw",                   // "Operator Read Write"
    ENG_READ_ONLY = "vcds:engineering-ro",                      // "Engineering Read Only"
    ENG_READ_WRITE = "vcds:engineering-rw",                     // "Engineering Read Write"
    CONSOLE_SUPPORT_READ_ONLY = "vcds:console-support-ro",      // "Console Support Read Only"
    CONSOLE_SUPPORT_READ_WRITE = "vcds:console-support-rw",     // "Console Support Read Write"
    DEVOPS_READ_ONLY = "vcds:devops-ro",                        // "DevOps Read Only"
    DEVOPS_READ_WRITE = "vcds:devops-rw",                       // "DevOps Read Write"
    // TODO: update dpx-inventory-* to vlr-inventory-* when available
    VLR_INVENTORY_READ_ONLY = "vcds:dpx-inventory-provider-ro", // "VLR Inventory Read Only"
    VLR_INVENTORY_READ_WRITE = "vcds:dpx-inventory-provider-rw" // "VLR Inventory Read Write"
}

export const OPERATOR_ROLES: OperatorRoleEnum[] = Object.values(OperatorRoleEnum);

export enum RoleTypesEnum {
    VLCR_ROLE = "VLCR_ROLE",
    VMCFS_ROLE = "VMCFS_ROLE",
    OPERATOR_ROLE = "OPERATOR_ROLE"
}

export enum VlrRoleEnum {
    // VLCR roles
    VLCR_ADMIN = "vcdr:administrator",       // "Orchestrator Admin"
    VLCR_DR_ADMIN = "vcdr:dr-admin",         // "DR Admin"
    VLCR_DR_SDDC_ADMIN = "vcdr:sddc-admin",  // "DR SDDC Admin"
    VLCR_DR_TESTER = "vcdr:dr-tester",       // "DR Tester"
    VLCR_AUDITOR = "vcdr:auditor",           // "Data Protection Auditor"
    VLCR_BACKUP_ADMIN = "vcdr:backup-admin", // "Protection Admin"

    // VLCR console roles
    CONSOLE_ADMIN = "vcdr:console-admin",                                 // "Global Console Admin"
    CONSOLE_ACTIVATE_DEPLOYMENT = "vcdr:console-activate-deployment",     // "Deployment Admin (Activation)"
    CONSOLE_DEACTIVATE_DEPLOYMENT = "vcdr:console-deactivate-deployment", // "Deployment Admin (Deactivation)"
    CONSOLE_SUBSCRIPTION_ADMIN = "vcdr:console-subscription-admin",       // "Subscription Admin"
    CONSOLE_SUBSCRIPTION_AUDITOR = "vcdr:console-subscription-auditor"    // "Subscription Auditor" (post-MVP)
}

export const VLCR_ROLES: VlrRoleEnum[] = Object.values(VlrRoleEnum);
export const VLCR_CONSOLE_ROLES: VlrRoleEnum[] = [
    VlrRoleEnum.CONSOLE_ADMIN,
    VlrRoleEnum.CONSOLE_ACTIVATE_DEPLOYMENT,
    VlrRoleEnum.CONSOLE_DEACTIVATE_DEPLOYMENT,
    VlrRoleEnum.CONSOLE_SUBSCRIPTION_ADMIN,
    VlrRoleEnum.CONSOLE_SUBSCRIPTION_AUDITOR];

export enum VmcfsRoleEnum {
    // VMCFS roles
    STORAGE_ADMIN = "vmcfs:administrator",                                 // "VMCFS Storage Admin"
    STORAGE_AUDITOR = "vmcfs:auditor",                                     // "Storage Auditor"
    FILESYSTEM_ADMIN = "vmcfs:filesystem-admin",                           // "Filesystem Admin"
    FILESYSTEM_ADMIN_RESTRICTED = "vmcfs:filesystem-admin-restricted",     // "Filesystem Delete Restricted"

    // VMCFS console roles
    CONSOLE_ADMIN = "vmcfs:console-admin",                                 // "Global Console Admin"
    CONSOLE_ACTIVATE_DEPLOYMENT = "vmcfs:console-activate-deployment",     // "Deployment Admin (Activation)"
    CONSOLE_DEACTIVATE_DEPLOYMENT = "vmcfs:console-deactivate-deployment", // "Deployment Admin (Deactivation)"
    CONSOLE_SUBSCRIPTION_ADMIN = "vmcfs:console-subscription-admin",       // "Subscription Admin"
    CONSOLE_STORAGE_ADMIN = "vmcfs:storage-admin",                         // "Storage Admin"
}

export const VMCFS_ROLES: VmcfsRoleEnum[] = Object.values(VmcfsRoleEnum);
export const VMCFS_CONSOLE_ROLES: VmcfsRoleEnum[] = [
    VmcfsRoleEnum.CONSOLE_ADMIN,
    VmcfsRoleEnum.CONSOLE_ACTIVATE_DEPLOYMENT,
    VmcfsRoleEnum.CONSOLE_DEACTIVATE_DEPLOYMENT,
    VmcfsRoleEnum.CONSOLE_SUBSCRIPTION_ADMIN,
    VmcfsRoleEnum.CONSOLE_STORAGE_ADMIN];

export enum CspRoleEnum {
    ORG_OWNER = "csp:org_owner",                                           // "Organization Owner"
    ORG_MEMBER = "csp:org_member",                                         // "Organization Member"
}

export enum UiPrivilegeEnum {
    VIEW_DEPLOYMENTS = "VIEW_DEPLOYMENTS",
    CREATE_DEPLOYMENT = "CREATE_DEPLOYMENT",
    DELETE_DEPLOYMENT = "DELETE_DEPLOYMENT",
    VIEW_SUBSCRIPTIONS = "VIEW_SUBSCRIPTIONS",
    VIEW_ACTIVITY_LOG = "VIEW_ACTIVITY_LOG",
    VIEW_SETTINGS = "VIEW_SETTINGS",
    OP_READ_ENTITIES = "OP_READ_ENTITIES",
    OP_WRITE_ENTITIES = "OP_WRITE_ENTITIES",
    NO_PRIVILEGES = "NO_PRIVILEGES"
}
